import { ReactElement } from 'react';
import { Card, Typography } from 'antd';
import isAudioExpired from '../../utils/isAudioExpired';
import AudioPlayer from './AudioPlayer';

interface Props {
  recordingId: number;
  duration: number | null;
  presignedUrl: string;
  registeredAt: Date;
}

const AudioSection = ({ recordingId, duration, presignedUrl, registeredAt }: Props): ReactElement => {
  if (isAudioExpired(registeredAt)) {
    return (
      <Card size='small'>
        <Typography.Text type='secondary'>録音データは保管期間を過ぎたため削除されました。</Typography.Text>
      </Card>
    );
  }

  return <AudioPlayer recordingId={recordingId} duration={duration} presignedUrl={presignedUrl} />;
};

export default AudioSection;
